interface UnauthenticatedProps {
  consoleURL: string
  fleetSlug: string
}

/**
 * Unauthenticated — shown when no valid bearer token is present.
 *
 * Mission Control runs no login. Authentication always happens at the console:
 * the user visits the console, it mints a fleet-scoped JWT, and deep-links
 * back to Mission Control with the token.
 *
 * Phase 1 flow: the user must manually supply the token via the URL hash or
 * query param (the console integration for automatic deep-link with token is
 * a Workstream A / Phase 2 task). For now, direct them to the console.
 */
export function Unauthenticated({ consoleURL, fleetSlug }: UnauthenticatedProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 shadow-sm p-8 text-center">
        <h1 className="text-xl font-semibold text-gray-900 capitalize">
          {fleetSlug} Mission Control
        </h1>
        <p className="text-sm text-gray-500 mt-2">
          Authentication is managed by the AgentFleet Console.
        </p>

        <div className="mt-6">
          <a
            href={consoleURL}
            className="inline-flex items-center justify-center px-4 py-2 rounded bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors"
          >
            Go to Console to authenticate
          </a>
        </div>

        <p className="text-xs text-gray-400 mt-4">
          You need a fleet grant for <strong>{fleetSlug}</strong> to access this Mission Control.
          Contact your platform administrator if you need access.
        </p>
      </div>
    </div>
  )
}
